// extracted by mini-css-extract-plugin
export default {"file-upload-container":"Dc8V_","active":"Gm_oC","extension-descriptions":"dge98","svg-wrapper":"sHecO","file-input":"waS56"};